import { redirect } from 'react-router-dom'
import { DrawerData as initialDrawerData } from '../../Constants/Constant/SidebarConstent'
import { getLocalStorage } from '../../Helpers/Storage'
import { checkModuleAccess } from '../../Helpers/Util'

export function authenticationGuard(): string | Response {
  const { token = '' } = getLocalStorage('auth_config') as any
  if (!token) return redirect('/login')
  if (token) {
    for (let i = 0; i < initialDrawerData?.length; i++) {
      const pathArray = window.location.pathname.split('/')
      const isEditOrCreatePath = pathArray.some(
        (segment) => segment === 'edit' || segment === 'create',
      )
      if (initialDrawerData[i].path.includes(`/${pathArray[1]}`)) {
        const moduleAccess = checkModuleAccess(initialDrawerData[i]?.role)
        if (!moduleAccess.canRead && !moduleAccess.canWrite) {
          return redirect('/access-denied')
        }

        if (isEditOrCreatePath && !moduleAccess.canWrite) {
          return redirect('/access-denied')
        }
      }
    }
  }
  return token
}
